// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"79044aba","1291":"79044aba","2919":"a59f8955","4525":"79044aba","5829":"79044aba","6259":"79044aba","6374":"41b90579"}[chunkId] + ".chunk.css";
};